/* ----------------- React Native Paper --------------- */
import { Card } from "react-native-paper";
import { Button } from "../../Button";

import { useTranslation } from "react-i18next";
import CardContainer from "../../CardContainer";
/* ----------------- Components --------------- */
import CardContent, { type MasteryListItemProps } from "./CardContent";

type Props = {
	title: string;
	subtitle: string;
	items: MasteryListItemProps[];
	handleClickCard?: () => void;
	cta?: string;
	icon?: string;
	tooltip?: string;
	tagType?: string;
};
export const StudySessionMasteryTagProgressCard = ({
	title,
	subtitle,
	items,
	handleClickCard,
	cta,
	icon,
	tooltip,
	tagType,
}: Props) => {
	const showViewAll = cta || handleClickCard;
	const finalItems = items.slice(0, 4);

	const { t } = useTranslation();

	const ActionsCard = () => {
		if (showViewAll) {
			return (
				<Card.Actions>
					<Button mode="text" onPress={handleClickCard}>
						{cta || t("common.viewDetails")}
					</Button>
				</Card.Actions>
			);
		}
		return null;
	};

	return (
		<CardContainer
			title={title}
			subtitle={subtitle}
			icon={icon || "tag-multiple-outline"}
			actions={<ActionsCard />}
			tooltip={tooltip}
		>
			<CardContent
				items={finalItems}
				tagType={tagType}
				handleClickCard={handleClickCard}
			/>
		</CardContainer>
	);
};
